import { render } from "./importpurchase.vue?vue&type=template&id=4854afae"
import script from "./importpurchase.vue?vue&type=script&lang=js"
export * from "./importpurchase.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__